import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvMarketplaceShoppingCartComponent } from '../cv-marketplace-shopping-cart/cv-marketplace-shopping-cart.component';
import { ThumbnailSlideService } from 'src/app/reusables/services/thumbnail-slide-service';

@Component({
  selector: 'cv-marketplace-shopping-cart-product-details',
  templateUrl: './cv-marketplace-shopping-cart-product-details.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart-product-details.component.scss']
})
export class CvMarketplaceShoppingCartProductDetailsComponent implements OnInit {

  @Output() showValidationMsg = new EventEmitter<any>();

  pscs: any = null;
  selectedVariation = null;
  productQuantity: number = 1;
  isQtyEmpty: boolean = false;
  showEmptyQtyMssg: boolean = false;
  variationRealPrice: number = 0;
  variationPrice: number = 0;
  variationSale: string = '';
  previousSelectedQty: number = 1;
  slideVariations = [];
  isVariationSelected: boolean = true;
  lastAdded = null;
  highlightCartItem: boolean = false;
  allowedQuantity: number = 20;
  _localizationStrings = new Map();

  disableAddToCartButton: boolean = false;

  isMainImageEmpty: boolean = false;

  @Output() setSelectedImageEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetQtyInput = new EventEmitter<void>();

  isCxone: boolean = false; 
  shoppingCartsService = null; 

  constructor(
    private cvNumberLocalize: CvNumberLocalizePipe,
    private shoppingCartService: ShoppingCartService,
    private cvLocalizationService: CVLocalizationService,
    private marketplaceShoppingCartComponent: CvMarketplaceShoppingCartComponent,
    private dialogService: CvCustomDialogService,
    private cvConfigurationService: CvConfigurationService,    
    private changeDetector: ChangeDetectorRef,
    private marketShoppingCartService: ThumbnailSlideService,
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
    this.isCxone = this.cvConfigurationService.isCxOne;
    this.shoppingCartsService = new ThumbnailSlideService();
  }
  

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.shoppingCartsService.updateResolution();
    this.shoppingCartsService.disableSliderBtn(this.pscs.pointStoreDetailedViewProduct?.MultipleImagesData?.length);  

    const products = this.shoppingCartsService.getProducts();
    const productOne = products.find(productGet => productGet.id === this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);

    if (productOne) { 
        this.shoppingCartsService.setButtonRight(productOne.buttonRight);
        this.shoppingCartsService.setButtonleft(productOne.buttonleft);
        this.shoppingCartsService.changeResolution(productOne, this.pscs.pointStoreDetailedViewProduct?.MultipleImagesData?.length);
    }      
  }

  ngOnInit(): void {
    this.shoppingCartsService.updateResolution();
    this.shoppingCartsService.disableSliderBtn(this.pscs.pointStoreDetailedViewProduct?.MultipleImagesData?.length);    
    this.loadLocalizations();

    if (this.pscs.pointStoreDetailedViewProduct.HasMultipleImages && (this.pscs.pointStoreDetailedViewProduct.ProductImageID == 0 || this.pscs.pointStoreDetailedViewProduct.ProductImageID == null)) {
      this.isMainImageEmpty = true;
      setTimeout(() => {
        this.displayDefaultImage(this.pscs.pointStoreDetailedViewProduct);
      }, 0);

    }

    //The following code snippet is to allow the numeric input of cxone to remain empty until the user enters a valid quantity:
    setTimeout(() => {
      let input = document.getElementsByClassName('numeric-selector-value')[0];
      input.addEventListener("blur", () => {
        if (this.isQtyEmpty) {
          let input: any = document.getElementsByClassName('numeric-selector-value');
          input[0].value = '';
        }
      })
    }, 0);
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this._localizationStrings = map;
    });
  }

  /**
  * Returns the localization for the provided Key, or defaultValue if missing.
  * @param key String's Key from the *.Language Section for this module
  * @param defaultValue String returned if localizations didn't load, or the key is missing.
  */
  getLocalizationString(key, defaultValue) {
    if (this._localizationStrings && this._localizationStrings.has(key))
      return this._localizationStrings.get(key);
    return defaultValue;
  }

  goBack() {
    this.pscs.shoppingCartIsProductSelected = false;
  }

  isOutOfStock(product): any {
    if (product !== null) {
      if (product.HasProductVariations) {
        if (this.selectedVariation !== null) {
          //session cart
          const sessionCart = this.shoppingCartService.shoppingCartObj.pointStoreCart.pointStoreProducts;
          let selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID === this.selectedVariation.PointStoreProductVariationID; });
          //find the current product variation in the session cart
          let validateSessionCart = sessionCart?.find(cart => cart.Variation === this.selectedVariation.PointStoreProductVariationID);

          if (selectedVariation !== null && (selectedVariation?.VariationQuantity === 0 ||
            selectedVariation?.VariationQuantity < 0 ||
            selectedVariation?.VariationQuantity === validateSessionCart?.Quantity//if is the same means the variation is currently unavailable
          )) {
            return true;
          }
        } else {
          const isOutOfStock = product.VariationsData?.reduce((acc, curr) => {
            const quantity = curr.VariationQuantity === null ? 1 : curr.VariationQuantity;//null means unlimited so consider 1 as default value
            return acc + quantity
          }, 0);
          return isOutOfStock === 0 ? true : false;
        }
      } else {
        return product.Quantity === 0 || product.Quantity < 0;
      }
    } else
      return false;
  }

  isCurrentSale(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }

    return false;
  }

  isFeatured(item: any): boolean {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 2);
    }

    return false;
  }

  setVariationData(product) {
    this.productQuantity = 1;
    this.previousSelectedQty = this.productQuantity;
    let inputs: any = document.getElementsByClassName('numeric-selector-value');
    inputs[0].value = this.previousSelectedQty;
    this.isQtyEmpty = false;
    this.showEmptyQtyMssg = false;
    this.variationRealPrice = this.getVariationRealPrice(product);
    this.variationPrice = this.getVariationPrice(product);
    this.variationSale = this.getVariationSale(product);

    this.isVariationSelected = true;

    if (product.HasProductVariations && product.VariationsData.length > 0 && product.HasMultipleImages && product.MultipleImagesData.length > 0) {
      let matchFound = false;

      //Looping through the product images (main product and variations)
      product.MultipleImagesData.forEach(image => {
        if (image.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID) {
          matchFound = true;
          this.setSelectedImg(product.PointStoreProductID, image.PointStoreProductImageID);
        }
      });

      //If an image wasn't found for the selected variation, the main product image is displayed instead
      if (!matchFound) {
        this.setSelectedImg(product.PointStoreProductID, product.ProductImageID);
      }
    }
  }

  getVariationRealPrice(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (product.HasVariationPrices) {
      if (variation.VariationOnSale && this.isCurrentSale(product)) {
        let price = variation.VariationPrice == null ? product.Price : variation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(price - (price * product.Sale) / 100));
      } else {
        return variation.VariationPrice == null ? new CvNumberLocalizePipe().transform(Math.ceil(product.Price)) : new CvNumberLocalizePipe().transform(Math.ceil(variation.VariationPrice));
      }
    } else {
      if (variation.VariationOnSale && this.isCurrentSale(product))
        return new CvNumberLocalizePipe().transform(Math.ceil(product.Price - (product.Price * product.Sale) / 100));
      else
        return new CvNumberLocalizePipe().transform(Math.ceil(product.Price));
    }
  }

  getVariationPrice(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (product.HasVariationPrices) {
      let price = variation.VariationPrice == null ? product.Price : variation.VariationPrice;
      return variation.VariationOnSale ? new CvNumberLocalizePipe().transform(price) : '';
    } else {
      return variation.VariationOnSale ? new CvNumberLocalizePipe().transform(product.Price) : '';
    }
  }

  getVariationSale(product) {
    let variation = null;
    product.VariationsData.forEach(v => {
      if (v.PointStoreProductID == this.selectedVariation.PointStoreProductID && v.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
        variation = v;
    });
    if (variation == null)
      return;
    return variation.VariationOnSale ? '(' + product.Sale + '% ' + this.getLocalizationString("OFF", "off") + ')': '';
  }

  setSelectedImg(productID, imageID) {
    let thumbnails = document.getElementsByClassName('detailed-thumbnail-dl-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].classList.remove('img-selected');
    }
    let thumbnailImg = <HTMLImageElement>document.getElementById('dt-' + imageID);
    if (thumbnailImg) {
      thumbnailImg.classList.add('img-selected');
    }

    let selectedImg = <HTMLImageElement>document.getElementById('selected-image-detail-' + productID);
    if (selectedImg) {
      selectedImg.src = '../Admin/ImageResizer.aspx?imgid=' + imageID + '&w=auto&h=388'
    }
  }

  goToNextImg(productID) {
    let selectedImg = null;
    let nextImage = null;
    let thumbnails = document.getElementsByClassName('detailed-thumbnail-dl-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains('img-selected')) {
        selectedImg = thumbnails[i];
        selectedImg.classList.remove('img-selected');
        nextImage = thumbnails[i + 1];
        if (nextImage == null) {
          nextImage = thumbnails[0];
        }
      }
    }
    nextImage.classList.add('img-selected');
    let mainImage = <HTMLImageElement>document.getElementById('selected-image-detail-' + productID);
    mainImage.src = nextImage.src;
  }

  goToPrevImg(productID) {
    let selectedImg = null;
    let prevImage = null;
    let thumbnails = document.getElementsByClassName('detailed-thumbnail-dl-' + productID);
    for (let i = 0; i < thumbnails.length; i++) {
      if (thumbnails[i].classList.contains('img-selected')) {
        selectedImg = thumbnails[i];
        selectedImg.classList.remove('img-selected');
        prevImage = thumbnails[i - 1];
        if (prevImage == null) {
          prevImage = thumbnails[thumbnails.length - 1];
        }
      }
    }
    prevImage.classList.add('img-selected');
    let mainImage = <HTMLImageElement>document.getElementById('selected-image-detail-' + productID);
    mainImage.src = prevImage.src;
  }
  validateValue(event, product) {
    let inputs: any = document.getElementsByClassName('numeric-selector-value');
    let value = inputs[0].value;
    //if value is not an integer:
    if (!(Number.isInteger(Number(value)) && Number(value) > 0)) {
      //if it is anything but the backspace then replace it with the previous valid value.
      if (event.keyCode != 8 && event.keyCode != 46) {
        this.productQuantity = this.previousSelectedQty;
        inputs[0].value = this.productQuantity;
        this.isQtyEmpty = this.productQuantity == null;
        this.showEmptyQtyMssg = this.productQuantity == null;
      } else {
        this.isQtyEmpty = true;
        this.productQuantity = null;
        this.previousSelectedQty = null;
      }
      //the value is an integer greater than 0:
    } else {
      let maxStock = this.getProductStock(product);
      //if the value entered is greater than the available stock, set the maximum stock instead.
      if (Number(value) > maxStock) {
        this.productQuantity = maxStock;
        this.previousSelectedQty = maxStock;
        inputs[0].value = maxStock;
      } else {
        this.productQuantity = value;
        this.previousSelectedQty = this.productQuantity;
        inputs[0].value = this.previousSelectedQty;
      }
      this.isQtyEmpty = false;
      this.showEmptyQtyMssg = false;
    }
  }

  checkQtyInput($event, product) {
    //Quantity changed by clicking + or - button
    if (Number.isInteger($event) && Number($event) > 0) {
      if (this.isQtyEmpty) {
        let inputs: any = document.getElementsByClassName('numeric-selector-value');
        inputs[0].value = '';
        return
      }
      else
        this.validateValue($event, product);
    } else {
      //Manually entered value
      setTimeout(() => {
        this.validateValue($event, product);
      }, 0);
    }
  }

  getProductStock(product) {
    if (product.HasProductVariations) {
      if (this.selectedVariation != null) {
        let variationQty = null;
        product.VariationsData.forEach(variaton => {
          if (variaton.PointStoreProductID == this.selectedVariation.PointStoreProductID && variaton.PointStoreProductVariationID == this.selectedVariation.PointStoreProductVariationID)
            variationQty = variaton.VariationQuantity;
        });
        if (variationQty > 0 && variationQty != null)
          return variationQty > 20 ? 20 : variationQty;
        else
          return 20
      } else {
        return 20;
      }
    } else {
      if (product.Quantity > 0 && product.Quantity != null)
        return product.Quantity > 20 ? 20 : product.Quantity;
      else
        return 20
    }
  }

  getProductPrices(product) {
    if (product != null) {
      if (product.HasProductVariations && product.HasVariationPrices && product.VariationsData != null && product.VariationsData.length) {
        let initialVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue < currValue ? prev : curr;
        });
        let lastVariation = product.VariationsData.reduce((prev, curr) => {
          let prevValue = prev.VariationPrice;
          let currValue = curr.VariationPrice;
          if (prev.VariationOnSale)
            prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
          if (curr.VariationOnSale)
            currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
          return prevValue > currValue ? prev : curr;
        });
        let initialVariationPrice = initialVariation.VariationOnSale ? (initialVariation.VariationPrice - (initialVariation.VariationPrice * (product.Sale / 100))) : initialVariation.VariationPrice;
        let lastVariationPrice = lastVariation.VariationOnSale ? (lastVariation.VariationPrice - (lastVariation.VariationPrice * (product.Sale / 100))) : lastVariation.VariationPrice;
        return new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));
      }
      else if (product.Sale != null && this.isCurrentSale(product)) {
        return product.CalculatedRealPrice;
      } else
        return product.Price;
    }
  }


  wishlistAction(product, $event) {
    $event.stopPropagation();
    if (product.isInWhisList)
      this.removeFromWishlist(product)
    else
      this.addToWishlistProduct(product);
  }

  async removeFromWishlist(product) {
    let response = await this.shoppingCartService.removeWishlistItem(product);
    if (response) {
      this.showValidationMsg.emit({ event: event, isAdding: false });
      this.pscs.pointStoreDetailedViewProduct.isInWhisList = false;
    }
  }

  async addToWishlistProduct(product) {
    let response = await this.shoppingCartService.addWishlistItem(product);
    if (response) {
      this.showValidationMsg.emit({ event: event, isAdding: true });
      this.pscs.pointStoreDetailedViewProduct.isInWhisList = true;
    }
  }

  async addCartProduct(product, quantity) {
    this.disableAddToCartButton = true;
    let invalidInputs = false;
    if (this.isQtyEmpty) {
      let inputs: any = document.getElementsByClassName('numeric-selector-value');
      inputs[0].value = "";
      this.showEmptyQtyMssg = true;
      invalidInputs = true;
    }
    if (product.HasProductVariations && (this.selectedVariation == null || this.selectedVariation < 1)) {
      this.isVariationSelected = false;
      invalidInputs = true;
    } else {
      this.isVariationSelected = true;
    }
    if (invalidInputs) {
      this.disableAddToCartButton = false;
      return;
    }

    if (!(this.pscs.pointStoreCart.pointStoreProducts.findIndex((p) => { return p.ProductID === product.PointStoreProductID; }) > -1)) {
      this.highlightCartItem = true;
    }
    this.pscs.shoppingCartShowLoader = true;

    let tempShoppingCartObject = Object.assign({}, this.pscs);

    //check session cart
    await this.shoppingCartService.getSessionCart();

    if (!this.checkAvailityToAddItemsToCart(product, quantity, this.selectedVariation?.PointStoreProductVariationID)) {
      this.pscs.shoppingCartShowLoader = false;
      this.disableAddToCartButton = false;
      return;
    }

    // this.shoppingCartService.addProductsToCart(product, quantity, this.selectedVariation).then((result: any) => {
    this.shoppingCartService.addProductsToCart(product, quantity, this.selectedVariation?.PointStoreProductVariationID).then((result: any) => {
      if (result) {
        if (this.pscs.pointStoreProductCarouselItems.findIndex((c) => { return c.PointStoreProductID == product.PointStoreProductID; }) > -1) {
          this.shoppingCartService.getCarouselItems();
          setTimeout(() => {
            this.setSelectedImageEvent.emit();
          }, 100);
        }

        this.pscs.pointStoreDetailedViewProduct.Quantity = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID; }).Quantity;

        this.lastAdded = product;
        this.productQuantity = 1;
        this.previousSelectedQty = this.productQuantity;
        this.isVariationSelected = true;
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = true;
        setTimeout(() => {
          this.pscs.shoppingCartShowLoader = false;
          this.disableAddToCartButton = false;
          this.marketplaceShoppingCartComponent.addCartProduct();
        }, 2000);

        this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
      } else {
        setTimeout(() => {
          this.pscs.shoppingCartShowLoader = false;
          this.disableAddToCartButton = false;
        }, 2000);
      }
      setTimeout(() => {
        this.resetQtyInput.emit();
      }, 0);
    });    
  }

  checkAvailityToAddItemsToCart(product, quantity, variationId): boolean {
    let isAvaliable: boolean = true;
    let totalItems: number = 0;
    //it is a product with variation or not
    let productCart = variationId == null ?
      this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID) :
      this.pscs.pointStoreCart.pointStoreProducts.find(x => x.ProductID == product.PointStoreProductID && x.Variation == variationId);

    //is the product in the cart?
    if (productCart) {
      totalItems = productCart.Quantity + Number(quantity);
      isAvaliable = totalItems > this.allowedQuantity ? false : true;

    } else {
      totalItems = quantity;
      isAvaliable = totalItems > this.allowedQuantity ? false : true;
    }

    //not available?
    if (!isAvaliable) {
      if (this.cvConfigurationService.isCxOne) {
        this.dialogService.showDialog(
          this.getLocalizationString("Warning_Text", "Warning"),
          this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'),
          1,
          '',
          this.getLocalizationString("Ok", "Ok"),
          true,
          () => { },
          () => { }
        );
      } else {
        showErrorMessage(this.getLocalizationString("Quantity_Added_Exceeds_Permitted_Limit", 'The quantity added exceeds the permitted limit.'));
      }
    }
    return isAvaliable;
  }

  displayDefaultImage(product: any): void {
    let images = product.MultipleImagesData;
    if (images.length > 0) {
      this.setSelectedImg(product.PointStoreProductID, images[0].PointStoreProductImageID);
    }
  }

  getVariantValidationMessage(variationType: string) {
    const defaultText = `Please select a ${variationType} variation.`;
    const localizedMessage = this.getLocalizationString('Please_Select_A_Variation', defaultText);
    return localizedMessage.replaceAll("{0}", this.getLocalizationString(variationType, variationType));
  }

}
